import { onMounted, watch } from 'vue'

/**
 * Composable to handle deprecation warnings for props.
 * @param props - The props object passed to the component.
 * @param deprecatedProps - An object where keys are deprecated prop names and values are warning messages or alternatives.
 * @param componentName - A string to determine which component has deprecated prop.
 */
export const useDeprecatedProps = (props, deprecatedProps, componentName) => {
  // Watch for changes to deprecated props if they are reactive
  Object.keys(deprecatedProps).forEach((propName) => {
    if (propName in props) {
      watch(
        () => props[propName],
        (newValue) => {
          if (newValue !== undefined && newValue !== null) {
            console.warn(`[${componentName}]: The prop "${propName}" is deprecated. ${deprecatedProps[propName]}`)
          }
        },
        { immediate: true }
      )
    }
  })
}
